import './Texture.less';
import { Unity, useUnityContext } from 'react-unity-webgl';
import { useEffect, useRef, useState } from 'react';
import Thumbnail from '@/assets/Thumbnail.png';
import Sidebar from './components/Sidebar/Sidebar.jsx';
import Rightbar from './components/Rightbar/Rightbar.jsx';
import Generate from './components/Generate/Generate.jsx';
import { SDService, projectController } from '@/api';
import img2imgPng1 from '@/utils/texture1.js';
import img2imgPng2 from '@/utils/texture2.js';
import img2imgPng3 from '@/utils/texture3.js';
import { useParams } from 'react-router-dom';
import PopNotEnoughBanlance from '@/components/PopNotEnoughBalance/PopNotEnoughBalance.jsx';
import ConfirmDialog from '@/components/ConfirmDialog/ConfirmDialog.jsx';
import { base64ToFile, blobToFile, blobUrlToFile, fileToBase64, uploadFile } from '@/utils/file.js';
let controlObj = { cancel: false };
import { useDispatch, useSelector } from 'react-redux';
import { setShowPricePage } from '@/store/slices/home.js';

import { Spin } from 'antd';
import { wait } from '@/utils/utils.js';
import toast from 'react-hot-toast';
import {
  checkInpaintArea,
  checkMain,
  disableWebGLInput,
  enableWebGLInput,
  gen2D,
  getControlnetImage,
  getInpaintTextures,
  getScreenShot,
  getUV,
  LoadModel,
  OnCancelGenerate,
  setDefinition,
  setLayerTexture,
  SetProjectImage,
} from '@/utils/unityTool.js';
import UnityModelLoading from '@/components/UnityModelLoading/UnityModelLoading.jsx';
import { base64ToBlob, fileToBlobUrl, imagesToBase64OrBlob } from '@/utils/image.js';
import { decrypted } from '@/utils/crypto.js';
import { setHasInpaintArea, setIsInpainting } from '@/store/slices/texture.js';
import { reportData } from '@/utils/trackingPoint.js';
import { info } from '@/utils/message.jsx';
export default function Texture() {
  const [loading, setLoading] = useState(true);
  const [showBanlanceModal, setShowBanlanceModal] = useState(false);
  const dispatch = useDispatch();

  const textureState = useSelector((state) => state.texture);

  // 是否在重绘
  const canInpaint = textureState.isInpainting && textureState.hasInpaintArea;

  const [progression, setProgression] = useState(0);
  const [progress, setProgress] = useState(0);
  const [generateImages, setGenerateImages] = useState(null);
  const [showGenerate, setShowGenerate] = useState(false);
  const { projectId } = useParams(); // 获取路径参数

  const [layer, setLayer] = useState(null);
  const [rightbarKey, setRightbarKey] = useState(1);
  const [textureNoseLoaded, setTextureNoseLoaded] = useState(false);
  const rightbarRef = useRef();
  const sidebarRef = useRef();
  const canvasRef = useRef(null);
  const projectDetail = useRef(null);
  const [devicePixelRatio, setDevicePixelRatio] = useState(window.devicePixelRatio);

  const { unityProvider, isLoaded, loadingProgression, sendMessage, unload } = useUnityContext({
    loaderUrl: `/test-unity/html/Build/html.loader.js`,
    dataUrl: `/test-unity/html/Build/html.data.br`,
    frameworkUrl: `/test-unity/html/Build/html.framework.js.br`,
    codeUrl: `/test-unity/html/Build/html.wasm.br`,
    workerUrl: `/test-unity/html/Build/html.data.unityweb`,
    streamingAssetsUrl: '/test-unity/html/StreamingAssets',
    companyName: 'MRStage',
    productName: 'AITexturePainter',
    productVersion: 'v0.1-20250411-r4',
    // 关键配置：禁用键盘捕获
    webglContextAttributes: {
      preserveDrawingBuffer: false,
      keyboardFocus: false, // 允许页面输入框接收键盘事件
    },
  });

  useEffect(() => {
    // 监听键盘按下
    document.addEventListener('keydown', function (event) {
      console.log('键盘按下:', event.key, '键码:', event.code);
    });

    return () => {
      console.log('unload 返回：', unload());
      disableWebGLInput(sendMessageRef.current);
      // 销毁 Unity WebGL 实例
      // unload()
      //   .then(() => {
      //     console.log('Unity 卸载完成');
      //   })
      //   .catch((err) => {
      //     console.warn('卸载失败：', err);
      //   });
    };
  }, []);

  const handleClickStop = async () => {
    // unityInstance.then((instance) => {
    //   instance.Quit().then(() => {
    //     console.log('Unity 卸载完成');
    //   });
    // });
    try {
      const res = await unload();
      console.log('unload', res);
    } catch (e) {
      console.error(e);
    }
  };

  const sendMessageRef = useRef(null);

  // window.SendMessage = sendMessage;

  const testCmd = async () => {
    // sendMessageRef.current(
    //   'ContextManager',
    //   'OnCmdExec',
    //   'Load https://texturenoise-staging.s3-accelerate.amazonaws.com/user/328500516914987008/project/1756197635929001/raw/stream_2.glb',
    // );
    await wait(5000);
    sendMessageRef.current('ContextManager', 'OnCmdExec', 'OnInpaint 1');
    await wait(1000);
    sendMessageRef.current('ContextManager', 'OnCmdExec', 'Gen2D');
    await wait(1000);

    sendMessageRef.current('ContextManager', 'OnCmdExec', 'GetInpaintTextures');
    await wait(1000);

    sendMessageRef.current(
      'ContextManager',
      'OnCmdExec',
      'RegulateTexWithMask https://texturenoise-staging.s3-accelerate.amazonaws.com/user/328500516914987008/image/1756458015908.task_file/7951b7ae-f9f6-495e-b636-3754422537a5/1.jpg',
    );
    await wait(5000);
    sendMessageRef.current(
      'ContextManager',
      'OnCmdExec',
      'SetProjectImage https://texturenoise-staging.s3.us-east-1.amazonaws.com/99172ce0-69c8-4275-9cef-1532bc6b9569.png',
    );
    await wait(5000);
    sendMessageRef.current('ContextManager', 'OnCmdExec', 'Gen2D');
    await wait(1000);
    sendMessageRef.current('ContextManager', 'OnCmdExec', 'GetInpaintTextures');
    await wait(1000);
    sendMessageRef.current(
      'ContextManager',
      'OnCmdExec',
      'SetProjectImage https://texturenoise-staging.s3-accelerate.amazonaws.com/user/328500516914987008/image/1756458048394.task_file/fd1fac80-4b6a-478d-990d-fd4b74fb36a6/1.jpg',
    );
  };

  useEffect(() => {
    setProgression((loadingProgression * 100).toFixed());
  }, [loadingProgression]);
  useEffect(() => {
    window.addEventListener('keydown', (e) => {}, true);
  }, [isLoaded]);

  useEffect(() => {
    // 禁用双指缩放
    document.addEventListener(
      'wheel',
      function (event) {
        // console.log('event', event);
        if (event.ctrlKey) {
          // Mac 触摸板双指缩放时 ctrlKey 为 true
          event.preventDefault();
        }
      },
      { passive: false },
    );

    window.onTexerFinishLoad = () => {
      // setTimeout(() => {
      queryDetail();
      // }, 200);
    };
    window.LoadingComplete = async () => {
      setDefinition(sendMessageRef.current, 1);
      if (projectDetail.current && projectDetail.current.texture) {
        const base64 = decrypted(projectDetail.current.texture);
        const url = await base64ToBlob(base64);
        await wait(200);
        setLayerTexture(sendMessageRef.current, url);
        await wait(1200);

        setLoading(false);
      } else {
        setLoading(false);
      }
      enableWebGLInput(sendMessageRef.current);
      const checkMainValue = await checkMain(sendMessageRef.current);
      console.log('checkMainValue', checkMainValue);
      sidebarRef.current.settingInpaintingStrengthEnable(checkMainValue == 1);

      reportData('edit-loading');
    };
    sidebarRef.current.resetInpant();
  }, []);

  useEffect(() => {
    sendMessageRef.current = (...params) => {
      sendMessage(...params);
    }; // 同步最新引用
  }, [sendMessage]);

  useEffect(() => {
    sidebarRef.current.changeInpant(textureState.isInpainting);
  }, [textureState.isInpainting]);

  const queryDetail = async () => {
    const res = await projectController.detail({
      projectId: projectId,
    });
    projectDetail.current = res.data;
    if (res.code == 0) {
      setTextureNoseLoaded(true);
      LoadModel(sendMessageRef.current, res.data.meshUrl);
      // testCmd();
    }
  };

  // 上传图片
  const uploadTexture = async (file) => {
    setLayerTexture(sendMessageRef.current, fileToBlobUrl(file));
  };

  // 保存封面图
  const saveThumbnail = async () => {
    const thumbnail = await getScreenShot(sendMessageRef.current);
    await wait(200);
    if (thumbnail) {
      const file = await blobUrlToFile(thumbnail, 'thumbnail');
      const coverimgResult = await uploadFile(file, 1);
      URL.revokeObjectURL(file);
      await projectController.thumbnail({
        body: {
          upload: {
            uploadId: coverimgResult.uploadId,
            completedParts: coverimgResult.eTags,
          },
        },
        projectId,
      });
    }
  };

  // 保存贴图
  const saveTexture = async () => {
    const uvImg = await getUV(sendMessageRef.current);
    const file = await blobUrlToFile(uvImg, 'texture');
    URL.revokeObjectURL(file);
    const coverimgResult = await uploadFile(file, 1);
    await projectController.saveTexture({
      body: {
        upload: {
          uploadId: coverimgResult.uploadId,
          completedParts: coverimgResult.eTags,
        },
      },
      projectId,
    });
    rightbarRef.current.settingIsSaving(false);
  };

  // 生成
  const generate = async (params) => {
    try {
      const checkInpaintAreaValue = await checkInpaintArea(sendMessageRef.current);
      console.log('checkInpaintAreaValue', checkInpaintAreaValue, textureState.isInpainting);
      dispatch(setHasInpaintArea(checkInpaintAreaValue == 1));

      rightbarRef.current.resetValues();
      const startTime = new Date().getTime();
      console.log('开始生成', new Date());
      await wait(200);

      setShowGenerate(true);
      setGenerateImages(null);
      setProgress(0);

      await gen2D(sendMessageRef.current);

      controlObj = { cancel: false };
      const endTime = new Date().getTime();
      const t1 = (endTime - startTime) / 1000;
      let url;
      if (checkInpaintAreaValue === 1 && textureState.isInpainting) {
        // 笔刷模式
        const texerImages = await getInpaintTextures(sendMessageRef.current);
        console.log('笔刷模式 window.texerImages', texerImages);
        const base64s = await imagesToBase64OrBlob(
          [texerImages.inputImg, texerImages.controlImg, texerImages.inpaintImg],
          false,
        );
        const base64InputTexture = base64s[0];
        const base64ControlNetImageTexture = base64s[1];
        const base64InpaintTexture = base64s[2];

        if (!base64InputTexture || !base64InpaintTexture || !base64ControlNetImageTexture) {
          info('waiting texture,please try again');
          setShowGenerate(true);
          setGenerateImages(null);
          setProgress(0);
          sidebarRef.current.settingGenerateButtonDisabled(false);
          return;
        }

        document.getElementById('initImage').src = base64InputTexture;
        document.getElementById('inpaintImage').src = base64InpaintTexture;
        document.getElementById('controlNetImage').src = base64ControlNetImageTexture;

        url = '/sdapi/v1/img2img';
        params.init_images = base64InputTexture.split(',')[1];
        params.mask = base64InpaintTexture.split(',')[1];
        params.image = base64ControlNetImageTexture.split(',')[1];

        base64s.forEach((item) => {
          URL.revokeObjectURL(item);
        });
      } else {
        // 文生图模式
        url = '/sdapi/v1/txt2img';
        console.log('文生图模式');

        const controlnet = await getControlnetImage(sendMessageRef.current);
        if (!controlnet) {
          sidebarRef.current.settingGenerateButtonDisabled(false);
          return;
        }
        console.log('文生图模式 window.texerImages', texerImages);
        const base64s = await imagesToBase64OrBlob([controlnet], false);
        const controlnetImg = base64s[0];
        params.image = controlnetImg.split(',')[1];
        document.getElementById('initImage').src = '';
        document.getElementById('inpaintImage').src = '';
        document.getElementById('controlNetImage').src = controlnetImg;
        base64s.forEach((item) => {
          URL.revokeObjectURL(item);
        });
      }
      const res = await SDService.submitTaskAndResponse(
        url,
        params,
        (progress) => {
          setProgress(progress);
        },
        controlObj,
        'POST',
        projectId,
      );

      if (!controlObj.cancel) {
        document.getElementById('resultImage').src = res.images[0];
        const seed = res.seed;
        console.log('返回的随机数====', seed);
        const t4Start = new Date().getTime();
        const images = await imagesToBase64OrBlob(res.images, true);
        // const images = res.images;
        const t4End = new Date().getTime();
        const t4 = (t4End - t4Start) / 1000;
        setGenerateImages(images);
        const endTime = new Date().getTime();
        console.log('点击到获取到unity图片耗时 T1', t1 + 's');
        console.log('SubmitTask T2', controlObj.t2 + 's');
        console.log('轮训 T3', controlObj.t3 + 's');
        console.log('下载贴图时间 T4', t4 + 's');
        console.log('总时间', (endTime - startTime) / 1000 + 's');
        sidebarRef.current.settingLastSeed(seed);

        // await wait(1000);
      }
      sidebarRef.current.settingGenerateButtonDisabled(false);

      // setTimeout(() => {
      // getInpaintTextures(sendMessageRef.current);
      // }, 1000);
    } catch (error) {
      console.error(error);
      sidebarRef.current.settingGenerateButtonDisabled(false);
    }
  };

  // 选择图片
  const chooseImage = async (item) => {
    dispatch(setIsInpainting(false));
    rightbarRef.current.settingIsSaving(true);
    setGenerateImages([item]);
    setShowGenerate(false);

    // let url = await imagesToBlobUrl(item.data);
    // console.log('url', url);
    // OnDiscardLayers(sendMessage);
    // reset(sendMessage);
    // const resizeImage = await resizeImageBlobUrl(item.data);
    SetProjectImage(sendMessageRef.current, item.data);
    // sendMessage(
    //   'ContextManager',
    //   'OnCmdExec',
    //   'SetProjectImage ' + item.data.replace('data:image/png;base64,', ''),
    // );
    sidebarRef.current.settingInpaintingStrengthEnable(true);
    rightbarRef.current.onGenerateFinish(generateImages.length === 1);
    setTimeout(async () => {
      await saveThumbnail();
      await saveTexture();
    }, 1000);
  };

  const changeBrushAndLayer = (brush, layer) => {
    sendMessageRef.current('ContextManager', 'OnCmdExec', 'brushOpen ' + 1 + ' 1');
    setBrush(brush);
    setLayer(layer);
  };

  const clickView = () => {
    sidebarRef.current.clickView();
  };

  return (
    <div
      className="texture"
      onClick={() => {
        clickView();
      }}>
      <Sidebar
        className="sidebar"
        ref={sidebarRef}
        onUploadTexture={(file) => {
          uploadTexture(file);
        }}
        sendMessage={sendMessageRef.current}
        onGenerate={(params) => {
          generate(params);
        }}></Sidebar>

      <div className="content">
        {/* {!loading && (
          <div className="loadingState">
            <img src={Thumbnail} />
            <div className="progress">
              <div className="progressItem" style={{ width: `${progression}%` }} />
              <div className="label">{progression}%</div>
            </div>
          </div>
        )} */}
        <div className="p-images">
          <div>
            <span>初始图</span>
            <img id="initImage"></img>
          </div>
          <div>
            <span>绘制图</span>
            <img id="inpaintImage"></img>
          </div>
          <div>
            <span>controlnet</span>
            <img id="controlNetImage"></img>
          </div>
          <div>
            <span>结果图</span>
            <img id="resultImage"></img>
          </div>
          <div>
            <span>渲染图</span>
            <img id="renderImage"></img>
          </div>
        </div>
        <div className="unity-content">
          <Unity
            unityProvider={unityProvider}
            className="unity-canvas"
            devicePixelRatio={devicePixelRatio}
            ref={canvasRef}
          />
        </div>
        {loading ? (
          <UnityModelLoading loadingProgression={loadingProgression * 100}></UnityModelLoading>
        ) : (
          <></>
        )}
      </div>
      <Rightbar
        ref={rightbarRef}
        key={rightbarKey}
        onBrushIsPaint={(value) => {
          dispatch(setIsInpainting(value));
        }}
        onShowBanlanceModal={() => {
          setShowBanlanceModal(true);
        }}
        className="rightbar"
        sendMessage={sendMessageRef.current}
        images={generateImages}></Rightbar>

      {showGenerate ? (
        <Generate
          single={canInpaint}
          sendMessage={sendMessageRef.current}
          onClose={() => {
            setGenerateImages(null);
            setShowGenerate(false);
            controlObj.cancel = true;
            sidebarRef.current.settingGenerateButtonDisabled(false);
            OnCancelGenerate(sendMessageRef.current);
          }}
          onChooseImage={(item) => {
            chooseImage(item);
          }}
          progress={progress}
          images={generateImages}
          className="generate"></Generate>
      ) : (
        <></>
      )}
      {showBanlanceModal && (
        <ConfirmDialog
          confirmTitle="Confirm to recharge"
          content="Insufficient balance, please recharge."
          onConfirm={() => {
            dispatch(setShowPricePage(true));
            setShowBanlanceModal(false);
          }}
          onCancel={() => {
            setShowBanlanceModal(false);
          }}></ConfirmDialog>
      )}
      {loading && <div className="block"></div>}
    </div>
  );
}
